/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AgroClimaticZone } from '../../models/agro-climatic-zone';

export interface GetAgroClimaticZone$Params {
   id: string;
}

export function getAgroClimaticZone(
   http: HttpClient,
   rootUrl: string,
   params: GetAgroClimaticZone$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<AgroClimaticZone>> {
   const rb = new RequestBuilder(rootUrl, getAgroClimaticZone.PATH, 'get');
   if (params) {
      rb.path('id', params.id, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<AgroClimaticZone>;
      })
   );
}

getAgroClimaticZone.PATH = '/api/weather/agro/climatic/zone/{id}';
